<div class="metadata-container scrollbar">
  <ng-template ngFor let-metadataItem [ngForOf]="metadataList">
    <div class="metadata-item">
      @if(metadataItem.url) {
        <a class="key" target="_blank" [href]="metadataItem.url" [ngbTooltip]="metadataItem.tooltip" placement="right">
          {{ metadataItem.key }}
        </a>
        } @else {
          <div class="key">
            {{ metadataItem.key }}
          </div>
        }
      <div class="value">
        {{ metadataItem.value }}
      </div>
    </div>
  </ng-template>
</div>
